module.exports = __webpack_public_path__ + "img/10.a980990a.jpg";